// This file is automatically generated. Do not edit it directly.
import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const SUPABASE_URL = (import.meta.env.VITE_SUPABASE_URL ?? "") as string;
const SUPABASE_PUBLISHABLE_KEY = (import.meta.env
  .VITE_SUPABASE_PUBLISHABLE_KEY ?? "") as string;

const isConfigured =
  SUPABASE_URL.length > 0 && SUPABASE_PUBLISHABLE_KEY.length > 0;

// Import the supabase client like this:
// import { supabase } from "@admin/integrations/supabase/client";

const _client: SupabaseClient<Database> | null = isConfigured
  ? createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
      auth: {
        storage: localStorage,
        persistSession: true,
        autoRefreshToken: true,
      },
    })
  : null;

const NOT_CONFIGURED_MSG =
  "Supabase is not configured. Add VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY to your .env file.";

export const supabase = new Proxy({} as SupabaseClient<Database>, {
  get(_, prop) {
    if (!_client) {
      throw new Error(NOT_CONFIGURED_MSG);
    }
    return (_client as Record<string | symbol, unknown>)[prop];
  },
});
